<template>
    <div class="pl-18 pr-18">
        <div class="pt-2">
            <div class="block-row ex-heading">
                <label class="row-lb font500">{{$t('tour.tour_name')}}</label>
                <div class="row-cnt mr-2">
                    {{tourInfo.name}}
                </div>
                <button class="btn btn-expand-detail ml-auto p-0" data-toggle="collapse" data-target="#tourInfor" aria-expanded="false">
                    <i class="icon-expand"></i>
                </button>
            </div>
        </div>
        <div class="collapse mb-4" id="tourInfor">
            <BizPrePaidCard
              :selectedBizPrePaidCard="selectedBizPrePaidCard"
              :showUseBizPrePaidCard="showUseBizPrePaidCard"
              @updateBizPrePaidCard="updateBizPrePaidCard"
            />
            <div class="detail-block box-info">
                <div class="block-row">
                    <label class="row-lb font500">{{$t('tour.tour_number')}}</label>
                    <div class="row-cnt">{{tourInfo.tour_number}}</div>
                </div>
                <div class="block-row">
                    <label class="row-lb font500">{{$t('tour.departure_date')}}</label>
                    <div class="row-cnt">{{dateUtils.formatDateYYYYMMDD(tourInfo.departure_date)}}</div>
                </div>
                <div class="block-row">
                    <label class="row-lb font500">{{$t('tour.return_date')}}</label>
                    <div class="row-cnt">{{dateUtils.formatDateYYYYMMDD(tourInfo.return_date)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StorageService from "@/services/common/storage.service";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import BizPrePaidCard from "@/views/components/sp/Voucher/BizPrePaidCard";
export default {
    name: "PCTourInfo",
    model: {
        prop: "selectedBizPrePaidCard",
        event: "updateBizPrePaidCard"
    },
    props: {
        selectedBizPrePaidCard: {
            type: { id: Number, name: String } | null,
            required: false
        },
        showUseBizPrePaidCard: {
            type: Boolean,
            required: false,
            default: false
        },
        tourInfoProp: {},
    },
    data() {
        return {
            utils: Utils,
            dateUtils: DateUtils,
            tourInfo: {},
            bizPrePaidCardSelector: Constants.bizPrePaidCard,
        };
    },
    created() {
        this.getData();
    },
    computed: {
        selectBizPrePaidCardoggle: function () {
            return this.selectedBizPrePaidCard;
        }
    },
    methods: {
        getData() {
            let tourInfo = JSON.parse(StorageService.getTour());
            if (!Utils.isEmptyObj(tourInfo)) {
                this.tourInfo = tourInfo;
            }
            else
                this.tourInfo = {};
        },
        updateBizPrePaidCard(select) {
            this.$emit("updateBizPrePaidCard", select);
        }
    },
    watch: {
        $route(to, from) {
            this.getData();
        },
        tourInfoProp: function tourInfoProp (newVal, oldVal) {
            this.tourInfo = this.tourInfoProp;
        },
    },
    components: { BizPrePaidCard }
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Tour/Info.vue